import { getResourceTo } from "react/utils/utils";

Greenmile.Event = Greenmile.Event || {};
Greenmile.Event.EventActionUtil = {

  updateMaxLengthWithAttributes: ({
    element,
    label,
    resourceKey,
    availableTags,
    maxlength,
    value
  }) => {
    const loadAvailableTags = Greenmile.Event.EventActionUtil.loadAvailableTags(availableTags);
    const countTextSpan = typeof label === 'string' ? document.querySelector(label) : label;
    let newValue = "";

    newValue = value;

    let attributesLength = 0;
    let attributesCount = 0;

    loadAvailableTags.forEach(tag => {
      let index = 0;
      newValue = newValue.replace(new RegExp(`@${tag.value}@`, 'g'), (match) => {
        attributesLength += match.length;
        attributesCount++;
        return index++ > 0 ? "" : match;
      });
    });

    // Retira o espaço ocupado pelo atributo (@attribute@) e põe pra ocupar o espaço de 10 caracteres
    const newMaxLength = maxlength + attributesLength - (attributesCount * 10);
    const count = newMaxLength - newValue.length;

    element.setAttribute('maxlength', newMaxLength);

    const replacedResource = Monet.I18n.getResourcesByKey(resourceKey, count.toString());
    const countTextNode = document.createTextNode(replacedResource);
    countTextSpan.innerHTML = '';
    countTextSpan.appendChild(countTextNode);
    element.value = newValue;
  },

  addListenerOnHttpRequestUrlInput: () => {
    const urlInput = document.querySelector('#action_http_url');
    const urlPreviewContainer = document.querySelector('#url-result-wrapper');

    urlInput.addEventListener('input', () => {
      urlPreviewContainer.innerHTML = '';
      urlPreviewContainer.appendChild(document.createTextNode(urlInput.value));
    });
  },

  getFieldHttpRequestApiKeyMethod: () => {
    const keyInput = document.querySelector('#key');
    const valueInput = document.querySelector('#value');
    const addKeyTo = document.querySelector('#addApiKey');

    return { keyInput, valueInput, addKeyTo };
  },

  cleanUrlPreview: () => {
    const url = document.querySelector('#action_http_url');
    const urlPreview = document.querySelector('#url-result-wrapper');

    urlPreview.innerHTML = '';
    urlPreview.appendChild(document.createTextNode(`${url.value}`));
  },

  addListenerToCountSizeInElement: (element, label, resourceKey, availableTags, maxlength) => {
    if(Greenmile.Event.EventActionUtil.validateAttributes(element, label, resourceKey, availableTags, maxlength)) {
      const inputListener = (event) => {
        event.stopPropagation();
        event.preventDefault();

        const actualValue = event.target.value;

        Greenmile.Event.EventActionUtil.updateMaxLengthWithAttributes(
          {
            element,
            label,
            resourceKey,
            availableTags,
            maxlength,
            value: actualValue
          }
        );
      };

      element.addEventListener(
        'input',
        inputListener
      );
    }
  },

  validateAttributes: (element, label, resourceKey, availableTags, maxlength) => {
    return element !== undefined &&
           label !== undefined && label !== "" &&
           resourceKey !== undefined && resourceKey !== "" &&
           availableTags !== undefined && availableTags !== "" &&
           maxlength !== undefined && maxlength > 0;
  },

  loadAvailableTags: (availableTags) => {
    switch (availableTags) {
      case "SMS":
        return Greenmile.Event.AutoComplete.loadSmsAvailableTags();
      case "EMAIL":
        return Greenmile.Event.AutoComplete.loadEmailAvailableTags();
      default:
        return [];
    }
  },

  setAttribute: (attribute, value, elements) => {
    if (elements) {
      elements.forEach(element => {
        if (element) {
          element[attribute] = value;
        }
      });
    }
  },

  changeCountCharacters: (element, defaultQuantity, newQuantity) => {
    if(Greenmile.Event.EventActionUtil.validateToChangeCountCharacters(element, defaultQuantity, newQuantity)) {
      element.innerHTML = element.innerText.replace(defaultQuantity, (defaultQuantity - newQuantity));
    }
  },

  setValueInCountCharacters: (element, defaultQuantity) => {
    if(Greenmile.Event.EventActionUtil.validateToSetValueCountCharacters(element, defaultQuantity)) {
      element.innerHTML = Monet.I18n.getResourcesByKey("event.textarea.charactersLeft", defaultQuantity);
    }
  },

  setHttpRequestUrlPreview: function(jsonParameter) {
    const urlPreview = document.querySelector('#url-result-wrapper');
    const { url } = jsonParameter

    urlPreview.appendChild(document.createTextNode(`${url}`));
  },

  setHttpRequestHeadersPreview: () => {
    const headers = GreenmileReduxStore.getState().configEventHttpHeadersModal.get("headers").toJS();
    const previewContainer = document.querySelector('#headers-result-wrapper');
    const dataForPreview = Object.entries(headers);

    previewContainer.innerHTML = '';
    const fragmentOfData = document.createDocumentFragment();
    dataForPreview.forEach((element) => {
      const [key, value] = element;
      const item = document.createElement('span');
      item.innerHTML = `<strong>${key}:</strong> ${value}`;
      fragmentOfData.appendChild(item);
    });
    previewContainer.appendChild(fragmentOfData);
  },

  validateToChangeCountCharacters: (element, defaultQuantity, newQuantity) => {
    return element !== undefined &&
      element !== null &&
      defaultQuantity !== undefined &&
      defaultQuantity !== null &&
      newQuantity !== undefined &&
      newQuantity !== null;
  },

  validateToSetValueCountCharacters: (element, defaultQuantity) => {
    return element !== undefined &&
      element !== null &&
      defaultQuantity !== undefined &&
      defaultQuantity !== null;
  },

  postRequestActionValidate: (pushErrorMessage) => ({
    clearErrors: (urlField, dataField) => {
      $('.post_request_data').removeClass('error');
      urlField
        .removeClass('error')
        .parent()
        .find('.action-http-url-error')
        ?.remove();
      dataField.removeClass('error');
    },

    validateURL: (element, validation) => {
      const urlRegex = /^https?:\/\/[^\s/$.?#].[^\s]*$/i;

      const urlValue = element.val();
      const urlCheckResourceKey = getResourceTo('event.check.postRequestAction.url');

      if (!urlRegex.test(urlValue)) {
        element
          .addClass('error')
          .parent()
          .append(`
            <span class="action-http-url-error">
              ${getResourceTo('event.check.postRequestAction.invalidURLFeedback')}
            </span>`
          );

        pushErrorMessage(
          validation,
          urlCheckResourceKey,
          'error.isrequired'
        );
      }
    },

    validateData: (element, validation) => {
      const dataCheckResourceKey = getResourceTo('event.check.postRequestAction.data');

      if (!element.val().length) {
        $('.post_request_data').addClass('error');
        element.addClass('error');

        pushErrorMessage(
          validation,
          dataCheckResourceKey,
          'error.isrequired'
        );
      }
    }
  })
};
